/*
Silhouette platane canonique — équivalent PWA du drawable Android
`res/drawable/ic_arbre_canonical.xml` (viewport 24×24). Path identique
à l'octet près. Tint via `fill="currentColor"` → cascade CSS color.

Utilisé là où Android utilise `ic_arbre_canonical` (header
SpeciesScreen) et comme placeholder visuel pour les fallback thumbnails
catalogue / timeline qui n'ont pas encore de photo user.
*/

const kCanonicalPath = 'M10.67,20 L10.67,14.67 C8.44,14.67 6.67,13.78 5.78,12 C4.89,11.56 4.89,9.78 5.33,8.44 C4.89,6.67 6.22,4.89 8,4.89 C8.44,3.56 10.22,2.67 12,2.67 C13.78,2.67 15.56,3.56 16,4.89 C17.78,4.89 19.11,6.67 18.67,8.44 C19.11,9.78 19.11,11.56 18.22,12 C17.33,13.78 15.56,14.67 13.33,14.67 L13.33,20 Z'

export function renderIconPlataneSvg(inClassName: string = ''): string
{
	return `<svg class="${inClassName}" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill="currentColor" d="${kCanonicalPath}"/></svg>`
}
